export default __webpack_public_path__ + "static/Autos2050_Logo_Color_KO_Tagline-6ddab855a0a041f818b9f95e65eb373c.png";